export default __webpack_public_path__ + "static/media/YAS0010.34I-27781_-16673_0.eb3f90dc.jpg";